<template>
  <!-- 显示在手机端的列表，整页滚动 -->
  <div class="mobile-list-header">
    <slot/>
  </div>
</template>

<script>

export default {
  props: {

  },
  name: "MLH",
  components: {},
  data() {
    return {};
  },
  created() {
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.mobile-list-header{
  box-sizing: border-box;
  padding: 10px;
  // 与第一条数据之间留出间距（列表卡片首条默认 margin-top:0）
  margin-bottom: 10px;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.1);
  background: #fff;
  border-top: 1px solid var(--yq-border-color);
  border-bottom: 1px solid var(--yq-border-color);
  :deep(.el-input){
    margin-bottom: 10px;
    font-size: var(--yq-font-size-small-mobile);
    .el-input__inner{
      height: 46px;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
  :deep(.el-select) {
    margin-bottom: 10px;
    .el-select__wrapper{
      font-size: var(--yq-font-size-small-mobile);
      height: 46px;
    }
    &:last-child{
      margin-bottom: 0;
    }
    .el-select-dropdown__item{
      font-size: var(--yq-font-size-small-mobile);
    }
  }
}
</style>